import * as styles from './index.module.scss';

import React from 'react';
import { findIndex } from 'lodash-es';
import Link from 'next/link';

import Caret from 'svgs/caret.svg';
import { CATEGORY_SUBSETS } from '@/contexts/categories_subset';

const PriceGuideLinks = () => {
  const [priceGuides, setPriceGuides] = React.useState([]);

  React.useEffect(() => {
    const guideLinks = [];

    const getPriceGuides = async () => {
      for (let categorySubset of CATEGORY_SUBSETS) {
        try {
          await import(`@/data/price_guide/${categorySubset.url_slug}`);

          // Make sure we don't have any duplicates.
          const index = findIndex(guideLinks, { label: categorySubset.name });

          if (index === -1) {
            // If we got this far, then the price guide exists. Use the category for the url generation.
            guideLinks.push({
              url: `/${categorySubset.url_slug}/price-guide`,
              label: categorySubset.name
            });
          }
        } catch (e) {
          //oopsy.
        }
      }
      setPriceGuides(guideLinks);
    };
    getPriceGuides();
  }, []);

  return (
    <div className={`${styles['price-guide-link-container']}`}>
      <div className={`container ${styles['container']}`}>
        <h2 id="price-guide">Popular Price Guides</h2>
        <div className={styles['price-guide-links']}>
          {priceGuides.map((link) => (
            <Link key={link.label} href={link.url}>
              {link.label} Price Guide <Caret />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PriceGuideLinks;
